import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, ArrowRight } from "lucide-react";
import { useCart } from "../contexts/CartContext";

export const StickyCartBar = () => {
    const { count, subtotal, setOpen } = useCart();
    const { pathname } = useLocation();

    if (count === 0) return null;
    if (pathname.startsWith("/checkout") || pathname.startsWith("/admin") || pathname.startsWith("/auth")) return null;

    return (
        <div
            data-testid="sticky-cart-bar"
            className="fixed bottom-0 left-0 right-0 z-30 bg-[#0c0c0e]/95 backdrop-blur-xl border-t border-white/10 shadow-[0_-10px_30px_rgba(0,0,0,0.6)] animate-fade-up"
        >
            <div className="mx-auto max-w-3xl px-3 py-3 flex items-center gap-3">
                <button
                    data-testid="sticky-cart-toggle"
                    onClick={() => setOpen(true)}
                    className="relative h-12 w-12 grid place-items-center bg-white/5 hover:bg-white/10 rounded-full transition shrink-0"
                    aria-label="Δες το καλάθι"
                >
                    <ShoppingCart size={18} />
                    <span className="absolute -top-1 -right-1 h-5 min-w-5 px-1 bg-brand-yellow text-black text-[10px] font-black grid place-items-center rounded-full">
                        {count}
                    </span>
                </button>
                <Link
                    to="/checkout"
                    data-testid="sticky-checkout-btn"
                    className="flex-1 h-12 flex items-center justify-between px-5 bg-gradient-to-r from-brand-red to-red-500 hover:from-brand-redhover hover:to-red-600 text-white font-heading uppercase tracking-wider text-sm font-black rounded-full transition active:scale-95 shadow-lg shadow-brand-red/30"
                >
                    <span className="flex items-center gap-2">
                        Παραγγελία
                        <ArrowRight size={16} strokeWidth={3} />
                    </span>
                    <span className="text-base">€{subtotal.toFixed(2)}</span>
                </Link>
            </div>
        </div>
    );
};
